export const GET_ACCESS_GOOGLE = "GET_ACCESS_GOOGLE"
export const GET_ACCESS_GOOGLE_SUCCESS = "GET_ACCESS_GOOGLE_SUCCESS"
export const GET_GOOGLE_API_ERROR = "GET_GOOGLE_API_ERROR"
